module.exports = __webpack_public_path__ + "static/media/img_career_optimized.e5b2883e.jpg";